import { useParams } from 'react-router-dom';

export const useUrl = {
  ProjectId: () => {
    const { projectId } = useParams<{ projectId: string }>();
    return projectId;
  },
  Tenant: () => {
    const { tenantId } = useParams<{ tenantId: string }>();
    return tenantId as string;
  },
  SchemaName: () => {
    const { schemaName } = useParams<{ schemaName: string }>();
    return schemaName;
  },
  DigitalTwinId: () => {
    const { digitalTwinId } = useParams<{ digitalTwinId: string }>();
    return digitalTwinId;
  },
  SchemaNameDT: () => {
    const { schemaNameDT } = useParams<{ schemaNameDT: string }>();
    return schemaNameDT;
  },
  CollectionReportId: () => {
    const { collectionReportId } = useParams<{
      collectionReportId: string;
    }>();
    return collectionReportId;
  },
  ConsistencyReportId: () => {
    const { consistencyReportId } = useParams<{
      consistencyReportId: string;
    }>();
    return consistencyReportId;
  },
  RuleId: () => {
    const { ruleId } = useParams<{ ruleId: string | undefined }>();
    return ruleId;
  },
};
